import { Stack, Text, Title } from '@mantine/core';

const AvailabilityPageHeader: React.FC = () => (
  <Stack
    gap={4}
    bg="gray.0"
    px="lg"
    py="md"
    flex="0 0 auto"
    style={{ borderBottom: '1px solid var(--mantine-color-gray-3)' }}
  >
    <Title order={4}>Availability calendar</Title>
    <Text size="sm" c="dimmed">
      Please confirm your availability per restaurant &amp; required product(s).
    </Text>
  </Stack>
);

export default AvailabilityPageHeader;
